import { labels } from "../localization/labels";

export const inullFilter = { filterType: "SELECT", filterVal: "inull" };

export const trueFilter = { filterType: "BOOLEAN", filterVal: "true" };

export const falseFilter = { filterType: "BOOLEAN", filterVal: "false" };

export const activeFilters = [
  {
    active: trueFilter
  },
  {
    active: falseFilter
  },
  {
    active: { filterType: "BOOLEAN", filterVal: undefined }
  }
];

export const labeledActiveFilters = [
  {
    ...activeFilters[0],
    label: labels.active,
    id: 0
  },
  {
    ...activeFilters[1],
    label: labels.inactive,
    id: 1
  },
  {
    ...activeFilters[2],
    label: labels.all,
    id: 2
  }
];

export const activeFilter = activeFilters[0];

export const activeFilterPageInfo = {
  filters: {
    ...activeFilter
  }
};

export const selectFilter = (value, comparator) => {
  return { filterType: "SELECT", comparator: comparator, filterVal: value };
};

export const textFilter = (value, comparator = "LIKE") => {
  return { filterType: "TEXT", comparator: comparator, filterVal: value };
};

export const nameFilter = {
  name: textFilter("")
};

export const modelNameFilter = {
  modelName: textFilter("")
};
